<template>
  <div :class="['ms-form', 'ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInput label="Сообщение" type="textarea" rows="5" :value="this.formData.message"
                     @change_input="(value) => onChange('message', value)" :required="true"/>
        <CustomUploader :value="this.formData?.files" :on-change="(value) => this.onChange('files', value)" label="Файлы" />
      </div>
      <CustomModalFooter :btn-loading="this.loading"/>
    </q-form>
  </div>
</template>
<script>

import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";

export default {
  name: "edit-chat-message",
  components: {CustomUploader, CustomInput, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        message: this.data?.body?.message || '',
        files: []
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
  computed: {
    costsTypes() {
      return this.$store.state.app.costsTypes;
    },
  }
}
</script>